// extracted by mini-css-extract-plugin
module.exports = {"customInput":"CustomInput_customInput__yNq4w","primary":"CustomInput_primary__F4F9D"};